import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { required } from "@gbli-events/common/src/Helpers/validators";
import SelectList from "@gbli-events/common/src/Components/FormElements/SelectList";
import CurrencyHelper from "Helpers/CurrencyHelper";
import initialFormValues from "Constants/initialFormValues";
import { useTheme } from "styled-components";

const propTypes = {
  drpValues: PropTypes.arrayOf(PropTypes.number).isRequired,
};

const DamageToRentedPremisesField = ({ drpValues }) => {
  const options = drpValues.map((value) => ({
    label: new CurrencyHelper(value).dollars(),
    value,
  }));

  const theme = useTheme();

  return (
    <Field
      name="ACDamageToRentedProperty"
      component={SelectList}
      theme={theme}
      options={options}
      placeholder="Select Coverage"
      validate={required}
      resetValue={initialFormValues().ACDamageToRentedProperty}
      components={{
        ClearIndicator: () => null,
      }}
    />
  );
};

DamageToRentedPremisesField.propTypes = propTypes;

export default DamageToRentedPremisesField;
